<template>
	<JBox class="s-bg-purple-600 s-border-t-2 s-border-purple-600 s-h-full s-overflow-y-scroll s-pb-64">
		<!-- Search -->
		<JFlex class="s-items-center s-sticky s-top-0">
			<JInputText
				v-model="searchTerm"
				placeholder="Search..."
				variant="ghost"
				class="s-w-full s-h-12 s-p-0 s-text-2xl s-text-purple-200 s-bg-purple-600 s-px-4 s-placeholder-purple-500 s-border-b s-border-purple-500"
			/>
			<JFlex
				class="s-justify-center s-items-center s-px-6 s-h-12 s-bg-purple-100 s-cursor-pointer"
				@click="searchTerm = ''"
				v-if="searchTerm"
			>
				<CIcon name="x" class="s-w-4 s-h-4 s-fill-current s-text-purple-600" />
			</JFlex>
		</JFlex>

		<!-- Body -->
		<JBox class="s-p-4">
			<template v-if="!searchTerm">
				<!-- Layout -->
				<JHeadline class="s-w-full s-text-xs s-font-semibold s-uppercase s-text-purple-300">Layout</JHeadline>
				<JDraggable
					v-model="categorizedElementsLibrary.layout"
					:sort="false"
					:animation="250"
					easing="cubic-bezier(1, 0, 0, 1)"
					:group="{ name: 'layout', pull: 'clone', put: false }"
					:clone="onClone"
					class="s-flex s-flex-wrap"
				>
					<JFlex
						v-for="(item, i) in categorizedElementsLibrary.layout"
						:key="i"
						class="s-w-56 s-m-1 s-p-3 s-pl-2 s-pr-3 s-bg-purple-900 s-text-purple-200  s-rounded s-text-xs s-cursor-move s-items-center"
					>
						<CIcon name="draggable-handle" class="s-text-purple-200 s-w-2  s-fill-current s-mr-2" />
						{{ item.component }}
					</JFlex>
				</JDraggable>

				<!-- Text -->
				<JHeadline class="s-w-full s-mt-4 s-text-xs s-font-semibold s-uppercase s-text-purple-300">Content</JHeadline>
				<JDraggable
					v-model="categorizedElementsLibrary.text"
					:sort="false"
					:animation="250"
					easing="cubic-bezier(1, 0, 0, 1)"
					:group="{ name: 'layout', pull: 'clone', put: false }"
					:clone="onClone"
					class="s-flex s-flex-wrap"
				>
					<JFlex
						v-for="(item, i) in categorizedElementsLibrary.text"
						:key="i"
						class="s-w-56 s-m-1 s-p-3 s-pl-2 s-pr-3 s-bg-purple-900 s-text-purple-200  s-rounded s-text-xs s-cursor-move s-items-center"
					>
						<CIcon name="draggable-handle" class="s-text-purple-200 s-w-2  s-fill-current s-mr-2" />
						{{ item.component }}
					</JFlex>
				</JDraggable>

				<!-- Form -->
				<JHeadline class="s-w-full s-mt-4 s-text-xs s-font-semibold s-uppercase s-text-purple-300">Form</JHeadline>
				<JDraggable
					v-model="categorizedElementsLibrary.form"
					:sort="false"
					:animation="250"
					easing="cubic-bezier(1, 0, 0, 1)"
					:group="{ name: 'layout', pull: 'clone', put: false }"
					:clone="onClone"
					class="s-flex s-flex-wrap"
				>
					<JFlex
						v-for="(item, i) in categorizedElementsLibrary.form"
						:key="i"
						class="s-w-56 s-m-1 s-p-3 s-pl-2 s-pr-3 s-bg-purple-900 s-text-purple-200  s-rounded s-text-xs s-cursor-move s-items-center"
					>
						<CIcon name="draggable-handle" class="s-text-purple-200 s-w-2  s-fill-current s-mr-2" />
						{{ item.component }}
					</JFlex>
				</JDraggable>

				<!-- Others -->
				<JHeadline class="s-w-full s-mt-4 s-text-xs s-font-semibold s-uppercase s-text-purple-300">Others</JHeadline>
				<JDraggable
					v-model="categorizedElementsLibrary.components"
					:sort="false"
					:animation="250"
					easing="cubic-bezier(1, 0, 0, 1)"
					:group="{ name: 'layout', pull: 'clone', put: false }"
					:clone="onClone"
					class="s-flex s-flex-wrap"
				>
					<JFlex
						v-for="(item, i) in categorizedElementsLibrary.components"
						:key="i"
						class="s-w-56 s-m-1 s-p-3 s-pl-2 s-pr-3 s-bg-purple-900 s-text-purple-200  s-rounded s-text-xs s-cursor-move s-items-center"
					>
						<CIcon name="draggable-handle" class="s-text-purple-200 s-w-2  s-fill-current s-mr-2" />
						{{ item.component }}
					</JFlex>
				</JDraggable>
			</template>

			<!-- Search Results  -->
			<template v-if="searchTerm">
				<JHeadline class="s-w-full s-text-xs s-font-semibold s-uppercase s-text-purple-300"
					>Found {{ searchedElementsLibrary.length }}</JHeadline
				>
				<JDraggable
					v-model="searchedElementsLibrary"
					:sort="false"
					:animation="250"
					easing="cubic-bezier(1, 0, 0, 1)"
					:group="{ name: 'layout', pull: 'clone', put: false }"
					:clone="onClone"
					class="s-flex s-flex-wrap"
				>
					<JFlex
						v-for="(item, i) in searchedElementsLibrary"
						:key="i"
						class="s-w-56 s-m-1 s-p-3 s-pl-2 s-pr-3 s-bg-purple-900 s-text-purple-200  s-rounded s-text-xs s-cursor-move s-items-center"
					>
						<CIcon name="draggable-handle" class="s-text-purple-200 s-w-2  s-fill-current s-mr-2" />
						{{ item.component }}
					</JFlex>
				</JDraggable>
			</template>
		</JBox>
	</JBox>
</template>

<script>
import { generateId, deepClone } from "@/utils/"
import { updateTree } from "@/utils/treeUtils"
import { buildBaseComponentsLibrary } from "../utils/"

export default {
	data() {
		return {
			elementsLibrary: [],
			searchTerm: ""
		}
	},

	computed: {
		categorizedElementsLibrary() {
			return {
				layout: this.elementsLibrary.filter(item => item?.tags?.includes("layout")),
				text: this.elementsLibrary.filter(item => item?.tags?.includes("text")),
				form: this.elementsLibrary.filter(item => item?.tags?.includes("form")),
				components: this.elementsLibrary.filter(item => item?.tags?.includes("others"))
			}
		},

		searchedElementsLibrary() {
			const regex = new RegExp(this.searchTerm, "gi")
			return this.elementsLibrary.filter(item => item?.component?.match(regex) || item?.label?.match(regex))
		},

		selectedComponentId() {
			return this.$store.state?.uiEditor?.selectedComponentId
		}
	},

	methods: {
		onClone(node) {
			// Check if node we are adding is itslef, if so prevent adding ot
			if (node.componentId === this.selectedComponentId) return

			const newNode = updateTree({
				tree: [node],
				updateFunction(node) {
					node.id = generateId()
				}
			})

			return newNode?.[0] ?? {}
		},

		generateCustomComponents() {
			return (
				this.$store?.state?.uiEditor?.app?.components?.map(item => ({
					componentId: item.id,
					component: item.name,
					tags: ["others"]
				})) ?? []
			)
		},

		getComponentsLibrary() {
			return deepClone([...buildBaseComponentsLibrary(), ...this.generateCustomComponents()])
		}
	},

	mounted() {
		this.elementsLibrary = this.getComponentsLibrary()
	}
}
</script>
